var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { SaveDraftRequest, } from '@millerknoll/pub-api-schema';
import { getDraft, saveDraft } from 'services/api/engineering-service';
export function handleEngRoyaltiesSave(royalties, productId, draftData) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var response;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(draftData === null || draftData === void 0 ? void 0 : draftData.header))
                        return [2 /*return*/, undefined];
                    draftData.header.royalties = royalties;
                    return [4 /*yield*/, saveDraft({
                            productId: productId,
                            productVersion: (_b = (_a = draftData.metadata) === null || _a === void 0 ? void 0 : _a.productVersion) !== null && _b !== void 0 ? _b : (_c = draftData.header) === null || _c === void 0 ? void 0 : _c.productVersion,
                            status: SaveDraftRequest.status.DRAFT,
                            header: draftData.header,
                        })];
                case 1:
                    response = _d.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
export function getFeatureDetails(props) {
    return __awaiter(this, void 0, void 0, function () {
        var productId, featureId, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    productId = props.productId, featureId = props.featureId;
                    if (!(productId && featureId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getDraft({ productId: productId, featureId: featureId })];
                case 1:
                    data = _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, data];
            }
        });
    });
}
export function mapProductHeaderToEngineeringHeaderRequest(prodHead) {
    if (!prodHead)
        return undefined;
    return {
        weightClassCode: prodHead === null || prodHead === void 0 ? void 0 : prodHead.weightClassCode,
        royalties: prodHead === null || prodHead === void 0 ? void 0 : prodHead.royalties,
        priceMatrixId: prodHead === null || prodHead === void 0 ? void 0 : prodHead.priceMatrixId,
        line: prodHead === null || prodHead === void 0 ? void 0 : prodHead.line,
        function: prodHead === null || prodHead === void 0 ? void 0 : prodHead.function,
        discountDescription: prodHead === null || prodHead === void 0 ? void 0 : prodHead.discountDesc,
        discountCode: prodHead === null || prodHead === void 0 ? void 0 : prodHead.discountCode,
    };
}
